export const normalizeExternalTicketId = (ticketId: string | null | undefined): string | null => {
  if (!ticketId) return null;
  return /^\d+$/.test(ticketId) ? String(Number(ticketId)) : ticketId;
};
